export default "__VITE_ASSET__0f70f3ad__"